import { useTranslation } from 'react-i18next';
import { CUSTOM_CATEGORIES } from 'utils/constants/casino/custom-categories';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { EmptyCasinoGames } from 'components/EmptyResultBoxes/EmptyCasinoGames';
import { useSelectedCategory } from '../../hooks/useSelectedCategory';
import { useCasinoGamesConfigsValues } from '../../providers/CasinoGamesConfigsContext';

export const EmptyCasinoGamesResult = () => {
  const { configs } = useCasinoGamesConfigsValues();
  const { t } = useTranslation();

  const { selectedCategory } = useSelectedCategory({ configs });

  const isFavoriteCategory = selectedCategory === CUSTOM_CATEGORIES.favorite.id;
  const isLastPlayedCategory =
    selectedCategory === CUSTOM_CATEGORIES.lastPlayed.id;

  return (
    <EmptyCasinoGames
      title={t(
        `emptyMessages.${
          isFavoriteCategory
            ? SpringConfigs.USER_PERSONALIZATION_ENABLED
              ? 'noCasinoPersonalizationFavorite'
              : 'noCasinoGameFavorite'
            : isLastPlayedCategory
            ? 'noCasinoGameLastPlayed'
            : 'noCasinoGame'
        }`
      )}
      gameText={t(
        `emptyMessages.${
          isFavoriteCategory
            ? SpringConfigs.USER_PERSONALIZATION_ENABLED
              ? 'noCasinoPersonalizationTextFavorite'
              : 'noCasinoGameTextFavorite'
            : isLastPlayedCategory
            ? 'noCasinoGameTextLastPlayed'
            : 'noCasinoGameText'
        }`
      )}
    />
  );
};
